import { useState } from "react";

import { Divider } from "@/components/Divider";
import { CovariateShiftEnableConfig, CovariateShiftThresholdConfig } from "@/components/monitoring/RuntimeConfig";
import { thresholdDesc } from "@/formatters/thresholds";

import { EditModelControls, Subtitle, Title, useModelEditor } from "./EditModel";
import { SegmentSelect } from "./SegmentSelect";

export const CovariateShiftSettings = () => {
  const { model, config, onRuntimeConfigChange } = useModelEditor();
  const [segmentId, setSegmentId] = useState<number>();

  return (
    <div className="p-4 flex flex-col w-fit max-w-[880px] gap-4">
      <Title>Covariate shift configuration</Title>
      <Subtitle>
        Configure which covariate shift methods to use. Specific column types can be selected to optimize compute.
      </Subtitle>
      <CovariateShiftEnableConfig
        problemType={model.problemType}
        config={config}
        value={model.runtimeConfig}
        onValueChange={onRuntimeConfigChange}
      />
      <Title>Covariate shift thresholds</Title>
      <Subtitle>{thresholdDesc}</Subtitle>
      <SegmentSelect segments={model.segments} onSegmentChange={(segment) => setSegmentId(segment?.id)} />
      <CovariateShiftThresholdConfig
        problemType={model.problemType}
        config={config}
        value={model.runtimeConfig}
        onValueChange={onRuntimeConfigChange}
        segmentId={segmentId}
      />
      <EditModelControls className="sticky bottom-0 py-4 -my-4 bg-dark" />
    </div>
  );
};
